export type HasUserNameParts = {
  first_name?: string | null;
  last_name?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  username?: string | null;
};

export function getUserDisplayName(user: HasUserNameParts | null | undefined): string {
  if (!user) return '';
  const firstName = user.first_name ?? user.firstName ?? '';
  const lastName = user.last_name ?? user.lastName ?? '';
  const full = `${firstName} ${lastName}`.trim();
  return full || user.username || 'Пользователь';
}

export function getInitialsFromName(name: string): string {
  const parts = name
    .split(' ')
    .map((p) => p.trim())
    .filter(Boolean);

  const first = parts[0]?.[0] ?? '';
  const second = parts[1]?.[0] ?? '';
  return (first + second).toUpperCase() || '?';
}
